module.exports = __webpack_public_path__ + "static/media/parachute-box.74534cc7.svg";